// extracted by mini-css-extract-plugin
module.exports = {"sliderWrapper":"vd__1USrW","prevButton":"vd__1fDG1","show":"vd__1qoUW","nextButton":"vd__3rAKy","scrollBar":"vd__JT17_","indicator":"vd__1pP-y"};